import { getIsDarkThemeFromParameter } from '../utils/optionalArgumentHelpers';
import { NEUTRAL_DARK_THEME_PALETTE } from '../constants/neutralDarkThemePalette';
import { NEUTRAL_LIGHT_THEME_PALETTE } from '../constants/neutralLightThemePalette';
import type { NeutralPalette } from '../schema/MiniPalette';

export const getRawNeutralPalette = (isDarkTheme?: boolean): NeutralPalette => {
    const effectiveIsDarkTheme = getIsDarkThemeFromParameter(isDarkTheme);
    return effectiveIsDarkTheme ? NEUTRAL_DARK_THEME_PALETTE : NEUTRAL_LIGHT_THEME_PALETTE;
};
